import { Canvas2DRenderer } from "./canvas2d.js";
import { WebGLRenderer } from "./webgl.js";
import type { Renderer } from "./types.js";

function formatRendererFallbackReason(error: unknown): string {
  if (error instanceof Error && error.message.trim() !== "") {
    return error.message.trim();
  }
  if (typeof error === "string" && error.trim() !== "") {
    return error.trim();
  }
  return "WebGL initialization failed.";
}

export function createRenderer(canvas: HTMLCanvasElement): Renderer {
  try {
    return new WebGLRenderer(canvas);
  } catch (error) {
    return new Canvas2DRenderer(canvas, formatRendererFallbackReason(error));
  }
}
